/**
 * Um título (ou medalha) em destaque: a mesma classificação do Top Comprador,
 * numa folha, com o contador na unidade da medida (PO, 20/09/2026).
 */
import { Sheet } from '../../ui/Sheet';
import { Icon, type IconName } from '../../ui/icons';
import { Classificacao, type Linha } from './Classificacao';

export function DestaqueSheet({
  nome,
  medida,
  icone,
  linhas,
  valor,
  meuMemberId,
  onFechar,
}: {
  nome: string;
  medida: string;
  icone: IconName;
  linhas: Linha[];
  valor: (n: number) => string;
  meuMemberId: string;
  onFechar: () => void;
}) {
  const temAlguem = linhas.some((l) => l.value > 0);
  return (
    <Sheet titleId="rk-destaque-titulo" onFechar={onFechar} testId="rk-destaque">
      <div className="rk__destaque-cab">
        <span className="rk__tile-icone"><Icon name={icone} size={17} /></span>
        <span className="rk__tile-texto">
          <h2 className="sheet__title rk__destaque-nome" id="rk-destaque-titulo">{nome}</h2>
          <span className="rk__tile-medida">{medida}</span>
        </span>
      </div>
      {temAlguem ? (
        <Classificacao linhas={linhas} valor={valor} meuMemberId={meuMemberId} testId="rk-destaque" />
      ) : (
        <p className="enq__vazio" data-testid="rk-destaque-vazio">Ninguém pontuou ainda. O primeiro a fazer leva o título.</p>
      )}
    </Sheet>
  );
}
